import React from 'react';
import useFetchWithStatus from 'hooks/fetchWithStatus';
import { Endpoints } from 'UI/constants/endpoints';

const API_VERSION = 1;

/**
 * @param {Object} props
 * @param {Object[]} props.phoneNumbers
 * @param {Function} props.renderRow
 */
const PhoneNumbersListing = ({ phoneNumbers, renderRow }) => {
  const { state: countryCodesState } = useFetchWithStatus(
    Endpoints.CountryCodes,
    null,
    null,
    API_VERSION
  );

  const { state: phoneTypesState } = useFetchWithStatus(
    Endpoints.PhoneTypes,
    null,
    null,
    API_VERSION
  );

  const catalogues = {
    countryCodes: countryCodesState?.results,
    phoneTypes: phoneTypesState?.results
  };

  return <>{phoneNumbers.map((item, index) => renderRow({ index, item, catalogues }))}</>;
};

export default PhoneNumbersListing;
